import React, { useState } from "react";

interface ExpandableListProps {
  items: string[];
  displayLimit?: number;
}

const ExpandableList: React.FC<ExpandableListProps> = ({
  items,
  displayLimit = 3,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasMore = items.length > displayLimit;
  const itemsToShow = isExpanded ? items : items.slice(0, displayLimit);

  if (items.length === 0) return null;

  return (
    <div className="flex flex-col items-center w-full px-4 mt-3">
      <div className="w-full max-h-[160px] overflow-y-auto custom-scrollbar">
        <ul className="flex flex-col items-center gap-1 list-none">
          {itemsToShow.map((item, idx) => (
            <li
              key={`${item}-${idx}`}
              className="flex items-center gap-2 text-[14px] font-medium text-[#1E293B] uppercase"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#1E293B]" />
              {item}
            </li>
          ))}
        </ul>
      </div>

      {!isExpanded && hasMore && (
        <button
          type="button"
          onClick={() => setIsExpanded(true)}
          className="mt-2 text-[14px] font-semibold text-[#0284C7] hover:underline"
        >
          +{items.length - displayLimit} More
        </button>
      )}
    </div>
  );
};

export default ExpandableList;
